export default "__VITE_ASSET__t4wJ1_IU__"